export default {"src":"/customer-services/_next/static/media/logo-john-lewis-insurance.18797d3f.svg","height":13,"width":111,"blurWidth":0,"blurHeight":0};